import React from 'react';
import { Common, color } from '@stockbit/ui';
import Image from 'global/Image';
import { trackAutoBuyTriggerPriceInfoSelected } from 'lib/analytics/autoOrder';
import { CustomTooltip, TooltipContainer } from './styled';
import { DATA_CY_MODAL_TRADING } from '../constant';

const { Flex, Text } = Common;

function TriggerPriceTooltip() {
  return (
    <Flex align="center" justify="flex-end">
      <Text align="right">Trigger Price</Text>
      <CustomTooltip
        overlayStyle={{ maxWidth: '281px' }}
        overlayInnerStyle={{
          padding: '12px',
          borderRadius: '4px',
        }}
        color={color.highempahis}
        title={
          <TooltipContainer>
            <Text size="12px" family="bold" color="inherit">
              Trigger Price
            </Text>
            <div style={{ height: '8px' }} />
            <Text size="12px" color="inherit">
              Trigger Price adalah kondisi harga yang harus terpenuhi agar order
              beli dapat dikirim.
            </Text>
          </TooltipContainer>
        }
        placement="bottom"
      >
        <Image
          src="/icon/info.svg"
          alt="type-info"
          style={{
            marginLeft: '5px',
            width: '12px',
            cursor: 'pointer',
          }}
          onMouseEnter={trackAutoBuyTriggerPriceInfoSelected}
          data-cy={DATA_CY_MODAL_TRADING.TRIGGER_PRICE_BUTTON_INFO}
        />
      </CustomTooltip>
    </Flex>
  );
}

export default TriggerPriceTooltip;
